"use client";
import { useTranslations } from "next-intl";
import { useLoveStore } from "@/lib/store/love.store";
import React, { useEffect, useState } from "react";

export default function HoverIcon({ className = "", AddCart, BuyBow, product = "" as any }) {
	const t = useTranslations("common");
	const [isLove, setIsLove] = useState(false);

	const { loveIds, setLoveProducts } = useLoveStore();
	useEffect(() => {
		if (loveIds.length && product?.id) {
			setIsLove(loveIds.includes(product.id));
		} else {
			setIsLove(false);
		}
	}, [loveIds]);

	const addOrDelLike = (event: React.MouseEvent) => {
		event.stopPropagation(); //
		const id = product?.id;
		if (id) {
			setLoveProducts(id);
		}
	};
	return (
		<div
			className={`hovericon absolute right-3 top-3 z-[3] flex translate-y-1 flex-col items-center gap-1.5 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 ${className}`}
		>
			<div
				className="tooltip-icon !flex h-8 w-8 cursor-pointer !items-center !justify-center rounded-lg border border-neutral-200 bg-white text-neutral-600 shadow-sm transition-colors duration-150 hover:bg-black hover:text-white"
				onClick={AddCart}
			>
				<i className="ri-shopping-cart-2-line text-[16px]"></i>
				<span className="tooltip-text absolute">{t("addToCart")}</span>
			</div>
			<div
				className="tooltip-icon !flex h-8 w-8 cursor-pointer !items-center !justify-center rounded-lg border border-neutral-200 bg-white text-neutral-600 shadow-sm transition-colors duration-150 hover:bg-black hover:text-white"
				onClick={BuyBow}
			>
				<i className="ri-shopping-bag-2-line text-[16px]"></i>
				<span className="tooltip-text absolute">{t("quickBuy")}</span>
			</div>
		</div>
	);
}
